module.exports = __webpack_public_path__ + "img/login-v2.845bd984.svg";